<br/><br/><br/><br/><br/><br/><br/><br/>

<h1 class="text-center text-primary">Pricelist</h1>
<hr class="text-center text-primary">

<h2 class="text-center text-secondary">Search</h2>

<div id="wrapper" class="container">

  <mat-tab-group #tabGroup animationDuration="0ms" mat-align-tabs="center" (selectedTabChange)="changeTab($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="custom-tab-label" [class.active]="tabGroup.selectedIndex === 0">Product Code</span>
      </ng-template>
      <form [formGroup]="searchForm" (ngSubmit)="searchForm.valid && search()" autocomplete="off" style="width: 95%;" >
        <br/>
        <div class="row" >

          <div class="col-4" >
            <app-text-input [formControl]='searchForm.controls["productcode"]' [label]='"Product Code"' ></app-text-input>


          </div>
          <div class="col-4">
            <div class="form-group">
              <label for="brand">Brand</label>

              <ng-select [items]="brands " [searchable]=false [clearable]=false
                [formControl]="searchForm.controls['brand']">
                <ng-template ng-option-tmp let-item="item">
                  {{item}}
                </ng-template>
              </ng-select>

            </div>

          </div>
        </div>

        <div class="form-group text-center">
          <button [disabled]='!searchForm.valid' class="btn btn-primary mr-2" type="submit">Search</button>
        </div>
      </form>

      <ng-template [ngTemplateOutlet]="MsgRef" ></ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="custom-tab-label" [class.active]="tabGroup.selectedIndex === 1">License Plate</span>
      </ng-template>
      <form [formGroup]="licensePlateForm" (ngSubmit)="licensePlateForm.valid && searchLicensePlate()" autocomplete="off" style="width: 95%;" >
        <br/>
        <div class="row" >
          <div class="col-4" >
            <div class="search-field-row licenseplate-search-row">
              <label class="search-field-label" for="licenseplate">License Plate</label>
              <input [formControl]='licensePlateForm.controls["licenseplate"]'  maxlength="8" class="inputLicenseplate"/>
            </div>
            <div class="search-field-row vin-input-wrapper">
              <label class="search-field-label vin-label">VIN</label>
              <ng-select
                [items]="vinHistory"
                [searchable]="true"
                [addTag]="addVinTag"
                [clearable]="true"
                [formControl]="licensePlateForm.controls['vin']"
                placeholder="Enter or select VIN"
                (search)="onVinSearch($event)"
                class="vin-ng-select">
              </ng-select>
            </div>
          </div>
          <div class="col-1 text-left search-button-column" >
            <div class="search-button-stack">
              <button [disabled]='!licensePlateForm.valid' class="btn btn-primary search-stack-button" type="submit">Search</button>
              <button [disabled]='!licensePlateForm.value.vin?.trim()' class="btn btn-primary search-stack-button vin-search-button" type="button" (click)="searchVin()">Search</button>
            </div>
            @if (toonLicenseplateInfo) {
              <div class="vehicle-search-summary">
                <b>{{licensePlateInfo.autoMerk}} {{licensePlateInfo.autoModel}} {{licensePlateInfo.autoType}}</b>
              </div>
            }
          </div>
        </div>
        <div class="row" >
          @if (toonLicenseplateInfo) {
            <div class="col-4 text-left"  >
              <br/>
              <br/><b>Motor Code:</b> {{licensePlateInfo.motorCode}}
              <br/><b>From:</b> {{licensePlateInfo.from}}
              <br/><b>Until:</b> {{licensePlateInfo.until}}
              <br/><b>Power:</b> {{licensePlateInfo.power}}
              <br/><br/>
            </div>
          }
          @if (toonLicenseplateInfo) {
            <div class="col-4 text-left"  >
              <br/>
              <br/>@if (licensePlateInfo.image?.length > 0) {
              <img src="{{licensePlateInfo.image}}" height="100" >
            }
          </div>
        }

      </div>
      <div class="row">
        @if (errorMessage?.length > 0) {
          <div class="col-4 text-left"  >
            <br/>
            <b>{{errorMessage}}</b>
            <br/>
          </div>
        }
      </div>

      @if (toonLicenseplateInfo) {
        <div class="row">
          <div class="col-4" >
            <ng-select [items]="licensePlateHoofdmenu"
              formControlName="licensePlateHoofdmenuSelected"
              (change)="changeHoofdgroep($event)">
              <ng-template ng-label-tmp let-item="item">
                <span >{{ item.hoofdGroep }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span >{{ item.hoofdGroep }}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-4" >
            <ng-select [items]="licensePlateSubmenu"
              formControlName="licensePlateSubmenuSelected"
              (change)="changeSubgroep($event)">
              <ng-template ng-label-tmp let-item="item">
                <span >{{ item.subGroep }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span >{{ item.subGroep }}</span>
              </ng-template>
            </ng-select>
          </div>
          <div class="col-4" >
            <ng-select [items]="licensePlateMenu"
              formControlName="licensePlateMenuSelected"
              (change)="changeGroep($event)"
              >
              <ng-template ng-label-tmp let-item="item">
                <span >{{ item.genOmschrijving }}</span>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
                <span >{{ item.genOmschrijving }}</span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      }

      <div class="row">
        <div class="col-4" >
          <br/>
        </div>
      </div>

    </form>

    <ng-template [ngTemplateOutlet]="MsgRef" accesskey="2"></ng-template>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <span class="custom-tab-label" [class.active]="tabGroup.selectedIndex === 2">Brand Model</span>
    </ng-template>
    <form [formGroup]="modelBrandForm"  autocomplete="off" style="width: 95%;" >
      <br/>
      <!-- <form [formGroup]="modelBrandForm" (ngSubmit)="licensePlateForm.valid && searchLicensePlate()" autocomplete="off" style="width: 95%;" > -->
      <div class="row" >
        <div class="col-4" >
          <label for="modelbrand">Brand</label>

          <ng-select [items]="modelbrands " [searchable]=false [clearable]=false formControlName="selectedModelBrand" bindLabel="name" bindValue="id"
            (change)="changeModelBrand($event)">
          </ng-select>
        </div>
        <div class="col-4" >
          <label for="modelmodel">Model</label>

          <ng-select [items]="modelmodels " [searchable]=false [clearable]=false formControlName="selectedModelModel" bindLabel="name"
            (change)="changeModelModel($event)">
          </ng-select>
        </div>
        <div class="col-4" >
          <label for="modeltype">Type</label>
          <ng-select [items]="modeltypes " [searchable]=false [clearable]=false formControlName="selectedModelType" bindLabel="name"
            (change)="changeModelType($event)">
          </ng-select>
        </div>
      </div>



      <div class="row" >
        @if (toonLicenseplateInfoModel) {
          <div class="col-4 text-left"  >
            <br/>
            <br/><b>Motor Code:</b> {{selectedModelType.motorCode}}
            <br/><b>From:</b> {{selectedModelType.from}}
            <br/><b>Until:</b> {{selectedModelType.until}}
            <br/><b>Power:</b> {{selectedModelType.power}}
            <br/><br/>
          </div>
        }
        @if (toonLicenseplateInfoModel) {
          <div class="col-4 text-left"  >
            <br/>
            <br/>@if (selectedModelModel.image?.length > 0) {
            <img src="{{selectedModelModel.image}}" height="100" >
          }
        </div>
      }


    </div>




    @if (errorMessage?.length > 0) {
      <div class="col-4 text-left"  >
        <br/>
        <b>{{errorMessage}}</b>
      </div>
    }

    @if (toonLicenseplateInfoModel) {
      <div class="row" >
        <div class="col-4" >
          <ng-select [items]="modelHoofdmenu"
            formControlName="modelHoofdmenuSelected"
            (change)="changeHoofdgroepModel($event)">
            <ng-template ng-label-tmp let-item="item">
              <span >{{ item.hoofdGroep }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span >{{ item.hoofdGroep }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-4" >
          <ng-select [items]="modelSubmenu"
            formControlName="modelSubmenuSelected"
            (change)="changeSubgroepModel($event)">
            <ng-template ng-label-tmp let-item="item">
              <span >{{ item.subGroep }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span >{{ item.subGroep }}</span>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-4" >
          <ng-select [items]="modelMenu"
            formControlName="modelMenuSelected"
            (change)="changeGroepModel($event)"
            >
            <ng-template ng-label-tmp let-item="item">
              <span >{{ item.genOmschrijving }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-search="searchTerm" let-index="index">
              <span >{{ item.genOmschrijving }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
    }

    <div class="row">
      <div class="col-4" >
        <br/>
      </div>
    </div>
  <!-- </form> -->
</form>






<ng-template [ngTemplateOutlet]="MsgRef" accesskey="1"></ng-template>
</mat-tab>
</mat-tab-group>



</div>



<ng-template #MsgRef >

  <form [formGroup]="orderForm" (ngSubmit)="orderForm.valid && onAddToBasket()" autocomplete="off">

    @if (searchpricelistlines === undefined || searchpricelistlines.length == 0) {
      <div>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
      </div>
    }

    <div formArrayName="searchlijn">
      @for (line of searchpricelistlines ; track line; let i = $index) {
        <div class="row">
          <div  class="col">
            <div class="card mb-4" [ngStyle]="{'background-color':line.isPromotie ? '#BDEDFF' : 'white'}" >
              <div class="card-body p-1">
                @if (line.isPromotie) {
                  <h6 class="card-title bg-dark mb-1">
                    <div class="container">
                      <div class="row text-light">
                        <div class="col">
                          <i class="fa fa-car mr-2"></i>
                          {{line.xref}} - @if (line.isDpmPrijslijst === true) {
                          <img src="../../../assets/dpm2.png" height="20" style="padding: 0px 10px 0px 0px;">
                          }{{line.omschrijving}}
                        </div>
                        <div class="col ">
                          <b>PROMOTION !!</b>
                        </div>
                        @if (line.levertermijn.length > 0) {
                          <div class="col">
                            Delivery time: {{line.levertermijn}}
                          </div>
                        }
                      </div>
                      @if (line.toonPrijslijstnummer) {
                        <div class="row text-light" >
                          @if (line.toonPrijslijstnummer) {
                            <div class="col">
                              Pricelist: {{line.prijslijstnummer}}
                            </div>
                          }
                          <div class="col ">
                          </div>
                          <div class="col" >
                            @switch (line.stockIndicator) {
                              @case (1) {
                                <img src="../../../assets/roodlicht2-klein.png" alt="No Stock" title="No Stock" height="40">
                              }
                              @case (2) {
                                <img src="../../../assets/oranjelicht2-klein.png" alt="Limited Stock" title="Limited Stock" height="40">
                              }
                              @case (3) {
                                <img src="../../../assets/groenlicht2-klein.png" alt="Stock Available" title="Stock Available" height="40">
                              }
                              <!-- Nothing for 0 or other values -->
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </h6>
                }
                @if (!line.isPromotie) {
                  <h6 class="card-title bg-light mb-1">
                    <div class="container">
                      <div class="row">
                        <div class="col">
                          <i class="fa fa-car mr-2"></i>
                          {{line.xref}} - @if (line.isDpmPrijslijst === true) {
                          <img src="../../../assets/dpm2.png" height="20" style="padding: 0px 10px 0px 0px;">
                          }{{line.omschrijving}}
                        </div>
                        @if (line.levertermijn.length > 0) {
                          <div class="col">
                            Delivery time: {{line.levertermijn}}
                          </div>
                        }
                      </div>
                      @if (line.toonPrijslijstnummer) {
                        <div class="row" >
                          @if (line.toonPrijslijstnummer) {
                            <div class="col">
                              Pricelist: {{line.prijslijstnummer}}
                            </div>
                          }
                          <div class="col" >
                            @switch (line.stockIndicator) {
                              @case (1) {
                                <img src="../../../assets/roodlicht2-klein.png" alt="No Stock" title="Red" height="40">
                              }
                              @case (2) {
                                <img src="../../../assets/oranjelicht2-klein.png" alt="Limited Stock" title="Orange" height="40">
                              }
                              @case (3) {
                                <img src="../../../assets/groenlicht2-klein.png" alt="Stock Available" title="Green" height="40">
                              }
                              <!-- Nothing for 0 or other values -->
                            }
                          </div>
                        </div>
                      }
                    </div>
                  </h6>
                }
                <div class="container">
                  <div class="row">
                    <div class="col-10">
                      <div class="row">
                        <div class="col-1">
                          Brand
                        </div>
                        <div class="col-1">
                          Part Number
                        </div>
                        <div class="col-1">
                        </div>
                        <div class="col-1">
                          Discount
                        </div>
                        <div class="col-1">
                          Group
                        </div>
                        <div class="col-2">
                          Gross Price
                        </div>
                        <div class="col-2">
                          Core
                        </div>
                        <div class="col-2">
                          <b>Your Price</b>
                        </div>
                      </div>
                    </div>
                    <div class="col-2">
                      Quantity
                    </div>
                  </div>
                  <div class="row align-items-start" >
                    <div class="col-10 align-top">
                      <div class="row align-top">
                        <div class="col-1 align-top">
                          <img src="../../../assets/{{line.merk.toLowerCase()}}.png" alt="{{line.merk}}" title="{{line.merk}}" height="20" >
                        </div>
                        <div class="col-1 align-top" >
                          {{line.partnumber}}<br/><br/>@if (line.image1?.length > 0) {
                          <button class="btn btn-primary mr-3" (click)="openPicture(pictureTemplate, line.image1, line.image2, line.image3, line.xref, line.documents)"><img src="../../../assets/camera.png" alt="Show image" Height="30" style="padding: 0px 0px 5px 0px;"></button>
                        }
                      </div>
                      <div class="col-1 align-top">
                        {{line.bonuscode}}
                      </div>
                      <div class="col-1 align-top">
                        {{line.kortingscode}}
                      </div>
                      <div class="col-1 align-top">
                        {{line.mli}}
                      </div>
                      <div class="col-2 align-top">
                        € {{line.brutoprijs.toFixed(2)}}
                      </div>
                      <div class="col-2 align-top">
                        € {{line.statiegeld.toFixed(2)}}
                      </div>
                      <div class="col-2 align-top">
                        <b>€ {{line.prijs.toFixed(2)}}</b>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">@if (line.productRemark?.length > 0) {
                        <div><i>Remark: {{line.productRemark}}</i></div>
                      }</div>
                      <div class="col-md-6"></div>
                    </div>
                  </div>
                  <div class="col-2">
                    <div class="form-group">
                      <ng-container [formGroupName]="i">
                        <input type="text" class="form-control" formControlName="qty"/>
                      </ng-container>
                    </div>
                    <button class="btn btn-success" type="submit" >Add to Order</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

  </div>
</form>
</ng-template>

<ng-template #pictureTemplate>


  <div class="row" >
    <div class="col-11">
      <h2>Product Code {{picturePartNumber}}</h2>
    </div>
    <div class="col-1">

      <button
        class="btn btn-danger"
        type="button"
        title="Close"
        (click)="pictureDialogRef?.close()"><b>X</b></button>
      </div>
    </div>

    <div class="row justify-content-center" style="padding: 10px 10px 10px 10px;">
      <img src="{{pictureUrlActive}}" height="{{dialogRefHeight}}" style="height:100; width:100">
    </div>
    <div class="row justify-content-center">
      <div class="col-2">
        <img src="{{pictureUrl1}}" height="60" (click)="changeActivePicture(1)" class="{{pictureStatus1}}">
      </div>
      <div class="col-2">
        <img src="{{pictureUrl2}}" height="60" (click)="changeActivePicture(2)" class="{{pictureStatus2}}" >
      </div>
      <div class="col-2">
        <img src="{{pictureUrl3}}" height="60" (click)="changeActivePicture(3)" class="{{pictureStatus3}}">
      </div>

    </div>
    @if (documentsAvailable === true) {
      <div>
        <div class="row" >
          <div class="col-11">
            <h3>Documents</h3>
            <hr>
            </div>
          </div>
          <div class="row" >
            @if (documents?.length > 0) {
              <div class="col-11">
                <table>
                  @for (document of documents; track document) {
                    <tr>
                      <div class="card" style="width: 18rem;">
                        <div class="text-center">
                          <img
                            src="../../../assets/{{document.fileType}}-icon.png"
                            alt="..."
                            width="50"
                            />
                          </div>
                          <div class="card-body">
                            <h5 class="card-title">{{document.description}}</h5>
                            <p class="card-text">
                            </p>
                            <a href="{{document.location}}" class="btn btn-primary" target="_blank" >Download</a>
                          </div>
                        </div>
                      </tr>
                    }
                  </table>
                </div>
              }
            </div>
          </div>
        }



      </ng-template>

      <ng-template #promotionTemplate>
        <div style="padding: 20px;">
          <div class="row">
            <div class="col-11">
              <h2>{{ customerPromotion?.name }}</h2>
              <p>
                <strong>Article:</strong> {{ customerPromotion?.xref }}<br/>
                <strong>Brand:</strong> {{ customerPromotion?.merk }}<br/>
                <strong>Valid from:</strong> {{ customerPromotion?.startDate | date:'dd/MM/yyyy' }}
                <strong>to:</strong> {{ customerPromotion?.endDate | date:'dd/MM/yyyy' }}
              </p>
            </div>
            <div class="col-1">
              <button class="btn btn-danger" type="button" title="Close" (click)="promotionDialogRef?.close()"><b>X</b></button>
            </div>
          </div>
          <div class="row justify-content-center" style="padding: 10px 0; height: 200px;">
            @if (customerPromotion?.fotoUrl) {
              <img
                src="{{ customerPromotion?.fotoUrl }}"
                style="object-fit: contain; width: 100%; height: 100%;" />
            } @else {
            }
            <ng-template #noPhoto></ng-template>
          </div>
          @if (customerPromotion?.priceTiers?.length > 0) {
            <div>
              <h4>Prices</h4>
              <table class="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Min. quantity</th>
                    <th>Max. quantity</th>
                    <th>Price</th>
                  </tr>
                </thead>
                <tbody>
                  @for (tier of customerPromotion?.priceTiers; track tier) {
                    <tr>
                      <td>{{ tier.minQuantity }}</td>
                      <td>{{ tier.maxQuantity === 0 ? '?' : tier.maxQuantity }}</td>
                      <td>{{ tier.price | currency:'EUR' }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
          <div class="row align-items-center" style="margin-top: 16px;">
            <div class="col-auto">
              <label for="promotionQty"><strong>Quantity:</strong></label>
            </div>
            <div class="col-auto">
              <input id="promotionQty" type="number" min="1" class="form-control" style="width: 100px;"
                [(ngModel)]="promotionQuantity" />
              </div>
              <div class="col-auto">
                <button class="btn btn-primary" type="button"
                  [disabled]="!promotionQuantity || promotionQuantity < 1"
                (click)="orderPromotion()">Order</button>
              </div>
            </div>
          </div>
        </ng-template>